/* import __COLOCATED_TEMPLATE__ from './instagram-card.hbs'; */
/* RESPONSIBLE TEAM: team-channels */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

export default class InstagramCard extends Component {
  @service appService;

  constructor() {
    super(...arguments);
  }

  get isCompact() {
    return this.args.compact;
  }

  get app() {
    return this.appService.app;
  }
}
